<template>
  <div class="stages__splitSection" :class="stageInfo.stageName">
    <div class="stages__text background--linear stages__splitItem">
      <div class="stages__textWrapper">
        <h6 class="stages__subtitle">{{stageInfo.title}}</h6>
        <p class="stages__desc" v-html="stageInfo.desc"></p>
        <ul class="stages__list">
          <li class="stages__listItem stages__listItem--flex" v-for="item in stageInfo.list" :key="item.name">
            <div class="stages__listImg">
              <img :src="item.image" alt="" class="img-fluid">
            </div>
            <div class="stages__listText">
              <h6 class="stages__listImgTitle">{{item.name}}</h6>
              <p class="stages__listInfo">{{item.info}}</p>
            </div>
          </li>
        </ul>
        <slot></slot>
      </div>
    </div>
    <div class="stages__img stages__splitItem">
      <div class="stages__imgWrapper">
        <p class="stages__imgText">{{stageInfo.imgText}}</p>
        <div class="stages__button">
          <section-button>{{stageInfo.buttonText}}</section-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Button from "../Shared/Button";
export default {
  props:{
    stageInfo:{
      type:Object,
      required:true
    }
  },
  components:{
    "section-button": Button
  }
}
</script>
<style scoped>
.stages__splitSection{
  display: flex;
  margin-top: 30px;
}

.stages__splitItem{
  width: 50%;
}

/* .stages__imgWrapper{
  padding: 75px 20%;
} */

.stages__imgWrapper{
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  height: 100%;
}

.stages__img{
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat; 
}


.stages__button{
  width: 100%;
}
.stages__imgText{
  font-family: "Seravek-Medium";
  font-size: 44px;
  color: var(--primary-color);
  text-align: center;
  /* padding-bottom: 41px; */
  margin-bottom: 0;
  width: 60%;
}

.stages__subtitle{
  font-family: "Seravek-Medium";
  font-size: 24px;
  line-height: 30px;
  color: var(--primary-color);
  margin-bottom: 0;
}

.stages__desc{
  font-family: "Seravek-Medium";
  font-size: 22px;
  color: var(--text-color);
  margin: 34px 0;
}


.stages__list{
  list-style: none;
  padding: 0;
  margin: 0;
}

.stages__listImgTitle{
  font-family: "Seravek-Medium";
  font-size: 22px;
  color: var(--primary-color);
  margin-bottom: 10px;
}

.stages__listItem .stages__listInfo{
  font-family: "Seravek-Light";
  font-size: 24px;
  color: var(--text-color);
  margin-bottom: 33px;
}

.stages__listItem:last-child .stages__listInfo{
  margin-bottom: 0;
}

.stages__listItem:last-child{
  margin-bottom: 50px;
}

.stages__listItem--flex{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.stages__listItem--flex .stages__listImg{
  width: 30%;
}

.stages__listItem--flex .stages__listImg img{
  width: 100%;
  height: 100%;
}

.stages__listItem--flex .stages__listText{
  width: 70%;
  margin-left: 20px;
  text-align: left;
}

.stages__listText .stages__listInfo{
  margin-bottom: 0;
}

.stages__tab1 .stages__img{
  background-image: url('../../assets/image/about/stage1/stage1.jpg'); 
}

.stages__tab2 .stages__img{
  background-image: url('../../assets/image/about/stage2/stage2.jpg'); 
}

.stages__tab3 .stages__img{
  background-image: url('../../assets/image/about/stage3/stage3.jpg'); 
}

.stages__textWrapper{
  margin: 0 auto;
  padding: 60px 0 24px 0;
}

.stages__tab1 .stages__textWrapper{
  width: 80%;
}

.stages__tab3 .stages__textWrapper,.stages__tab2 .stages__textWrapper{
  width: 90%;
}

.stages__tab1 .stages__list{
  padding: 0;
  margin: 0;
}

.stages__tab1 .stages__listItem{
  background-image: url('../../assets/image/about/list-type.png');
  background-repeat: no-repeat;
  background-position: left top;
  padding-left: 50px;
  list-style: none;
}

.stages__tab1 .stages__listInfo span{
  color: var(--primary-color);
  text-transform: uppercase;
} 

.stages__tab3 .stages__text {
  order: 2;
}

.stages__tab3 .stages__subtitle,.stages__tab2 .stages__subtitle{
  text-align: center;
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 480px) {
  .stages__splitSection{
    flex-direction: column;
  }

  .stages__splitItem{
    width: 100%;
  }

  .stages__wrapper{
    margin: 25px 0 35px 0;
  }

  .stages__tab1 .stages__textWrapper{
    width: 90%;
  }

  .stages__textWrapper{
    padding: 30px 0;
  }

  .stages__subtitle{
    font-size: 20px;
    line-height: 24px;
  }

  .stages__desc{
    font-size: 20px;
    line-height: 24px;
    margin: 15px 0;
  }

  .stages__tab1 .stages__listItem{
    padding-left: 40px;
  }

  .stages__listItem .stages__listInfo{
    font-size: 20px;
    line-height: 22px;
    margin-bottom: 20px;
  }

  .stages__imgText{
    font-size: 26px;
    width: 85%;
    margin-bottom: 10px;
  }

  .stages__button{
    width: 95%;
  }

  .stages__imgWrapper{
    padding: 30px 0;
  }

  .stages__listImgTitle{
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stages__tab3 .stages__text{
    order: 0;
  }
}

/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 481px) and (max-width: 767px) {
  .stages__imgText{
    width: 80%;
    font-size: 22px;
    padding-bottom: 40px;
  }

  .stages__imgWrapper{
    justify-content: center;
  }
  .stages__button{
    padding: 0 15px;
  } 
  .stages__subtitle{
    font-size: 20px;
    line-height: 22px;
  }
  .stages__desc{
    font-size: 20px;
    margin: 20px 0;
  }
  .stages__listItem .stages__listInfo{
    font-size: 18px;
    margin-bottom: 20px;
    line-height: 24px;
  }
  .stages__tab1 .stages__listItem{
    padding-left: 35px;
  }
  .stages__textWrapper{
    padding: 30px 0 0;
  }
  .stages__listImgTitle{
    font-size: 18px;
    margin-bottom: 5px;
  }
}

/* Tablets, Ipads (portrait) */
@media (min-width: 768px) and (max-width: 1024px) {
  
  .stages__imgText{
    width: 80%;
    font-size: 26px;
    padding-bottom: 40px;
  }

  .stages__imgWrapper{
    justify-content: center;
  }
  .stages__button{
    padding: 0 15px;
  } 
  .stages__subtitle{
    font-size: 22px;
    line-height: 24px;
  }
  .stages__desc{
    font-size: 22px;
    margin: 22px 0;
  }
  .stages__listItem .stages__listInfo{
    font-size: 20px;
    margin-bottom: 24px;
    line-height: 26px;
  }
  .stages__tab1 .stages__listItem{
    padding-left: 40px;
  }
  .stages__textWrapper{
    padding: 40px 0 0;
  }
  .stages__listImgTitle{
    font-size: 20px;
    margin-bottom: 5px;
  }
}

</style>